import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { ThreeColumnsCompaniesGridCardStoryblok } from '../../../../types/storyblok';

export const ThreeColumnsCompaniesGridCard = ({
  company,
  companyLogo,
  description,
  bkgImage,
}: ThreeColumnsCompaniesGridCardStoryblok) => {
  if (!company && !companyLogo && !description && !bkgImage) {
    return null;
  }

  return <Box as="section">ThreeColumnsCompaniesGridCard</Box>;
};

export default ThreeColumnsCompaniesGridCard;
